export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

export type Option = {
  label: string;
  value: string;
};

export type ValidationError = string;

export type ValidateNewItemAction = (item: string) => ValidationError | undefined;

export interface CreatableListProps {
  value: Option[];
  onChange?: (value: Option[]) => void;
  validateNewItem?: ValidateNewItemAction;
  formatOptionLabel?: (option: Option) => React.ReactNode;
  disabled?: boolean;
  error?: boolean;
  actions?: React.ReactNode;
  isLoading?: boolean;
  suggestions?: {
    label: string;
    notification: string;
    options: Option[];
    pending?: boolean;
  };
  placeholders?: {
    input?: string;
    copy?: string;
    copied?: string;
    paste?: string;
    pasted?: string;
    clearAll?: string;
    selected?: string;
    create?: string;
    total?: string;
    totalSeparator?: string;
    sortOrderAsc?: string;
    sortOrderDesc?: string;
    errorTitle?: string;
    errorAccessDenied?: string;
    errorAccessError?: string;
    errorValueExists?: string;
    errorValueEmpty?: string;
  };
  dataTestId?: string;
  allowSpacing?: boolean;
}
